<button mat-button [ngClass]="backgroundType">
    <mat-icon>{{iconName}}</mat-icon>
    <span class="text">{{text}}</span>
</button>